export const ADD_NEW_USER_STAFF_PREFERENCES =
  '[user] add new user staff preferences';
export const PROCESS_NEW_USER_STAFF_PREFERENCES =
  '[user] process new user staff preferences';
export const USER_STAFF_PREFERENCES_CREATE_ERROR =
  '[user] add new user staff preferences error';
export const EDIT_USER_STAFF_PREFERENCES = '[user] edit user staff preferences';
export const PROCESS_EDIT_USER_STAFF_PREFERENCES =
  '[user] process edited user staff preferences';
export const EDIT_USER_STAFF_PREFERENCES_ERROR =
  '[user] edit user staff preferences error';
export const CATEGORY_DISPLAY_ITEMS_GET_ERROR =
  '[user] get category display error';
export const EDIT_USER_CATEGORY_DISPLAY_ITEMS_ERROR =
  '[user] edit user category display error';
export const INSERT_USER_PREFERENCES = '[user] insert user preferences';

export const GET_CATEGORY_DISPLAY_ITEMS = '[user] get category display items';
export const PROCESS_CATEGORY_DISPLAY_ITEMS =
  '[user] process category display items';
export const PROCESS_APPEND_CATEGORY_DISPLAY_ITEMS =
  '[user] process append category display items';
export const INSERT_CATEGORY_DISPLAY_ITEMS =
  '[user] add category display items';
export const APPEND_CATEGORY_DISPLAY_ITEMS =
  '[user] append category display items';

export const EDIT_USER_CATEGORY_DISPLAY_ITEMS =
  '[user] edit user category display items';
export const PROCESS_EDIT_USER_CATEGORY_DISPLAY_ITEM =
  '[user] process edited user category display item';
export const PROCESS_DELETE_USER_CATEGORY_DISPLAY_ITEM =
  '[user] process deleted user category display item';
export const INSERT_CATEGORY_DISPLAY_ITEM =
  '[user] insert user category display item';
export const DELETE_CATEGORY_DISPLAY_ITEM =
  '[user] delete user category display item';

export const GET_ALERT_GROUP_PERMISSIONS =
  '[user] get user alert group permissions';
export const PROCESS_ALERT_GROUP_PERMISSIONS =
  '[user] process user alert group permissions';
export const INSERT_ALERT_GROUP_PERMISSIONS =
  '[user] insert user alert group permissions';
export const EDIT_ALERT_GROUP_PERMISSIONS =
  '[user] edit user alert group permissions';
export const ADD_ALERT_GROUP_PERMISSION =
  '[user] add user alert group permission';
export const PROCESS_ADDED_ALERT_GROUP_PERMISSIONS =
  '[user] process added user alert group permissions';
export const INSERT_ADDED_ALERT_GROUP_PERMISSIONS =
  '[user] insert added user alert group permissions';
export const REMOVE_ALERT_GROUP_PERMISSION =
  '[user] remove user alert group permission';
export const PROCESS_REMOVED_ALERT_GROUP_PERMISSIONS =
  '[user] process removed user alert group permissions';
export const DELETE_REMOVED_ALERT_GROUP_PERMISSIONS =
  '[user] delete removed user alert group permissions';

export const addNewUserStaffPreferences = (
  preferences,
  navigate,
  previous,
  formSteps
) => ({
  type: ADD_NEW_USER_STAFF_PREFERENCES,
  payload: preferences,
  navigate: navigate,
  previous: previous,
  formSteps,
});

export const processNewUserStaffPreferences = () => ({
  type: PROCESS_NEW_USER_STAFF_PREFERENCES,
});

export const userStaffPreferenceCreateError = () => ({
  type: USER_STAFF_PREFERENCES_CREATE_ERROR,
});

export const editUserStaffPreferences = (
  preferences,
  navigate,
  previous,
  formSteps
) => ({
  type: EDIT_USER_STAFF_PREFERENCES,
  payload: preferences,
  navigate: navigate,
  previous,
  formSteps,
});

export const processEditUserStaffPreferences = () => ({
  type: PROCESS_EDIT_USER_STAFF_PREFERENCES,
});

export const userStaffPreferenceEditError = () => ({
  type: EDIT_USER_STAFF_PREFERENCES_ERROR,
});

export const insertUserPreferences = (preferences) => ({
  type: INSERT_USER_PREFERENCES,
  payload: preferences,
});

export const getCategoryDisplayItems = () => ({
  type: GET_CATEGORY_DISPLAY_ITEMS,
});

export const processCategoryDisplayItems = () => ({
  type: PROCESS_CATEGORY_DISPLAY_ITEMS,
});
export const insertCategoryDisplayItems = (items) => ({
  type: INSERT_CATEGORY_DISPLAY_ITEMS,
  payload: items,
});

export const appendCategoryDisplayItems = (items) => ({
  type: APPEND_CATEGORY_DISPLAY_ITEMS,
  payload: items,
});

export const categoryDisplayItemsGetError = () => ({
  type: CATEGORY_DISPLAY_ITEMS_GET_ERROR,
});

export const editUserCategoryDisplayItems = (
  categories,
  navigate,
  previous,
  formSteps
) => ({
  type: EDIT_USER_CATEGORY_DISPLAY_ITEMS,
  payload: categories,
  navigate: navigate,
  previous,
  formSteps,
});

export const processUserCategoryDisplayItem = (data) => ({
  type: PROCESS_EDIT_USER_CATEGORY_DISPLAY_ITEM,
  payload: data,
});
export const processDeleteUserCategoryDisplayItem = () => ({
  type: PROCESS_DELETE_USER_CATEGORY_DISPLAY_ITEM,
});

export const userCategoryDisplayEditError = () => ({
  type: EDIT_USER_CATEGORY_DISPLAY_ITEMS_ERROR,
});

export const insertUserCategoryDisplayItem = (category) => ({
  type: INSERT_CATEGORY_DISPLAY_ITEM,
  payload: category,
});

export const deleteUserCategoryDisplayItem = (categoryId) => ({
  type: DELETE_CATEGORY_DISPLAY_ITEM,
  payload: categoryId,
});

export const getAlertGroupPermissions = () => ({
  type: GET_ALERT_GROUP_PERMISSIONS,
});
export const processAlertGroupPermissions = (payload) => ({
  type: PROCESS_ALERT_GROUP_PERMISSIONS,
  payload,
});
export const insertAlertGroupPermissions = (payload) => ({
  type: INSERT_ALERT_GROUP_PERMISSIONS,
  payload,
});
export const editAlertGroupPermissions = (payload, navigate) => ({
  type: EDIT_ALERT_GROUP_PERMISSIONS,
  payload,
  navigate,
});
export const addAlertGroupPermission = (payload, navigate) => ({
  type: ADD_ALERT_GROUP_PERMISSION,
  payload,
  navigate,
});
export const processAddedAlertGroupPermissions = (payload) => ({
  type: PROCESS_ADDED_ALERT_GROUP_PERMISSIONS,
  payload,
});
export const insertAddedAlertGroupPermissions = (payload) => ({
  type: INSERT_ADDED_ALERT_GROUP_PERMISSIONS,
  payload,
});
export const removeAlertGroupPermission = (payload, navigate) => ({
  type: REMOVE_ALERT_GROUP_PERMISSION,
  payload,
  navigate,
});
export const processRemovedAlertGroupPermissions = (payload) => ({
  type: PROCESS_REMOVED_ALERT_GROUP_PERMISSIONS,
  payload,
});
export const deleteRemovedAlertGroupPermissions = (payload) => ({
  type: DELETE_REMOVED_ALERT_GROUP_PERMISSIONS,
  payload,
});
